export const getENV = () => {
    const { hostname } = window.location;
    // 增加stage适配 update by boomer 2022-01-05 11:17:42
    if (/\w+-stage/.test(hostname)) {
        return "stage";
    }
    // 增加-pre适配 预上线环境 update by boomer 2021-10-22 10:20:17
    if (/pre((view)?)-\w+/.test(hostname) || /\w+-pre((view)?)/.test(hostname)) {
        return "preview";
    }
    if (/guazi.com/.test(hostname) || /guazi-apps.com/.test(hostname) || /maodou.com/.test(hostname)) {
        return "production";
    }
    if (/guazi-mock/.test(hostname) || /maodou-mock/.test(hostname)) {
        return "mock";
    }
    if (/guazi-cloud/.test(hostname) || /maodou-cloud/.test(hostname)) {
        return "development";
    }
    return "development";
};
